import React from "react";
import "./Home-cards.css";
import { Fade } from "react-awesome-reveal";

function HomeCards() {
  return (
    <div className="main-cards-box">
      <Fade cascade damping={0.3}>
      <h2 className="cardsTitle">Know us more</h2>
      <div className="card-container">
        <figure class="snip1567">
          <img
            src="https://media.istockphoto.com/id/1199796265/es/foto/bloques-de-madera-de-letras-del-alfabeto-con-palabras-give-en-las-manos-de-los-ni%C3%B1os-y-los.jpg?s=612x612&w=0&k=20&c=IIYKmQUKMryunGn9YXaupxNpH8f-bC5IOz91ZJXV83A="
            alt="soulplates"
            style={{ width: "400px" }}
          />

          <figcaption>
            <h3>Beneficiaries</h3>
            <p>
              Join our community of compassionate donors and make a meaningful
              impact today.
            </p>
          </figcaption>

          <div class="hover"></div>
          <i class="ion-android-add"></i>
        </figure>

        <figure class="snip1567">
          <img
            src="https://media.istockphoto.com/id/1303107115/es/foto/voluntarios-de-pie.jpg?s=612x612&w=0&k=20&c=d3XG5fCBke4TeOJptcUa_s-H_3__bXz-F_NT921jq6k="
            alt="soulplates"
            style={{ width: "400px" }}
          />

          <figcaption>
            <h3>Volunteers</h3>
            <p>
              Join our dedicated team of volunteers and be a force for positive
              change.
            </p>
          </figcaption>

          <div class="hover"></div>
          <i class="ion-android-add"></i>
        </figure>

        <figure class="snip1567">
          <img
            src="https://img.freepik.com/free-photo/close-up-volunteers-with-food-donations_23-2149196112.jpg?size=626&ext=jpg&ga=GA1.2.1147927255.1696541744&semt=sph"
            alt="soulplates"
            style={{ width: "400px" }}
          />

          <figcaption>
            <h3>What we do</h3>
            <p>
              We are a dedicated team of individuals driven by compassion, and
              we work tirelessly to bring about positive change in our
              communities.
            </p>
          </figcaption>

          <div class="hover"></div>
          <i class="ion-android-add"></i>
        </figure>

        <figure class="snip1567">
          <img
            src="https://uploads-ssl.webflow.com/5c579a2bc3ddd3316ce85540/613a36c7f8deeafb8e387054_5fg06VI_q_k1rhKlRBNuOwMi1nccHRK7637mKNm9AWZW46K4CMpxflx38wgm-hH8IEoQfXOWpZ7lkvMz7YtrKul-UZHjXApeoV9cfifxYxWovRdoGU0hen2HL-8OH1PdNP9L7LYF%3Ds0.jpeg"
            alt="soulplates"
            style={{ width: "400px" }}
          />

          <figcaption>
            <h3>Success stories</h3>
            <p>
              Our success stories are a testament to the power of community,
              kindness, and support.
            </p>
          </figcaption>

          <div class="hover"></div>
          <i class="ion-android-add"></i>
        </figure>
      </div>
      </Fade>
    </div>
  );
}

export default HomeCards;
